import { DispatcherEvent } from '@carvana/merch-native';
import { useEffect } from 'react';
import { NativeModalId } from '~/context/flp/ModalContext/constants';
import { useModalContext } from '~/context/flp/ModalContext/ModalContext';
import sendMessageToNative from './sendMessageToNative';

function sendMessageToOpenNativeModal(
  modal: NativeModalId,
  onError: () => void,
  payload: Record<string, any> = {}
) {
  sendMessageToNative(
    DispatcherEvent.OpenModal,
    { modal, ...payload },
    { onError }
  );
}

export default function useModalMessageDispatcher() {
  const {
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isSoftPullModalOpen,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setSoftPullModalOpen
  } = useModalContext();

  useEffect(() => {
    if (
      isAddCoApplicantModalOpen ||
      isEditCoApplicantModalOpen ||
      isSoftPullModalOpen
    ) {
      sendMessageToOpenNativeModal(NativeModalId.SoftPull, () => {
        setSoftPullModalOpen(false);
        setAddCoApplicantModalOpen(false);
        setEditCoApplicantModalOpen(false);
      });
    }
  }, [
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isSoftPullModalOpen,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setSoftPullModalOpen
  ]);
}
